// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import opinionRequestEntity from './entities/opinion-request.json';
import opinionRequestMenu from '../pages/opinion-request/menu.json';
import opinionRequestFullForm from '../pages/opinion-request/forms/full.json';
import opinionRequestContextForm from '../pages/opinion-request/forms/context.json';
import opinionRequestMiniForm from '../pages/opinion-request/forms/mini.json';
import opinionRequestLookupForm from '../pages/opinion-request/forms/lookup.json';
import opinionRequestTableView from '../pages/opinion-request/views/table.json';
import opinionRequestCardsView from '../pages/opinion-request/views/cards.json';
import opinionRequestCalendarView from '../pages/opinion-request/views/calendar.json';
import opinionRequestDashboardView from '../pages/opinion-request/views/dashboard.json';

/** Тип запису «Запит на висновок» зі сторінками пакета: меню, форми та подання з pages/opinion-request/. */
export const opinionRequestDefinition: IRecordTypeDefinition = {
  ...opinionRequestEntity,
  views: assembleViewSet({
      table: opinionRequestTableView,
      cards: opinionRequestCardsView,
      calendar: opinionRequestCalendarView,
      dashboard: opinionRequestDashboardView,
  }),
  form: opinionRequestFullForm,
  forms: { full: opinionRequestFullForm, context: opinionRequestContextForm, mini: opinionRequestMiniForm, lookup: opinionRequestLookupForm },
  menu: opinionRequestMenu,
} as IRecordTypeDefinition;
